import { render, staticRenderFns } from "./amount_bets.vue?vue&type=template&id=358b9cb4&"
import script from "./amount_bets.vue?vue&type=script&lang=js&"
export * from "./amount_bets.vue?vue&type=script&lang=js&"
import style0 from "./amount_bets.vue?vue&type=style&index=0&id=358b9cb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports